export default class Palette {
    static PRIMARY_COLOR = "#e11428"
    static GREY = "#a1a1a1"
    static WHITE = '#FFFFFF'
}